/* This file is autogenerated, see readme.md for instructions */
import ConstantSvgIcon from '@bloomreach/banana-theme/icons/constant.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ConstantIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ConstantSvgIcon />
    </Icon>
  );
});

ConstantIcon.displayName = 'ConstantIcon';

export default ConstantIcon;
